import useGetCompanyProductsByUser from "hooks/User/GetProductsByUser/useGetProductsByUser";
import { navbar } from "./defaultNavItems";
import { useEffect, useState } from "react";
import { navItem } from "types/CMS/Unum/Navbar/navbar";
import { allProductTypes } from "types/enums/Products/Products";
import { useKontentItems } from "../useGetItems/useGetItems";
import { globalSiteResolver } from "models/cms/kontent_model/Resolvers/GlobalSite/GlobalSite";
import { GlobalSite } from "../../../types/CMS/KontentAI/content-types/site";
import { useAppSelector } from "hooks/reduxhooks";

const useNavbar = () => {
  const { companyProductsByUser } = useGetCompanyProductsByUser();
  const [navItems, setNavItems] = useState<navItem[]>([]);
  const userRole = useAppSelector((state) => state.userSlice.role);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  let productsCache: allProductTypes[] | undefined;

  const getProducts = async () => {
    if (productsCache) {
      return productsCache;
    }
    try {
      productsCache = await companyProductsByUser();
    } catch {
      productsCache = [];
    }
    return productsCache;
  };

  const { fetchData } = useKontentItems({
    type: "site",
    resolver: async (data: GlobalSite[]) => {
      try {
        return globalSiteResolver(data, {
          usersProducts: await getProducts(),
          usersRoles: userRole,
        });
      } catch {
        return undefined;
      }
    },
    depth: 10,
  });

  useEffect(() => {
    const loadNavItems = async () => {
      setIsLoading(true);
      try {
        const kontent = await fetchData();
        if (!kontent.isError && kontent?.data) {
          setNavItems(kontent.data.primaryNavigation.items);
        } else throw new Error("No navbar content found");
      } catch {
        setNavItems(navbar(await getProducts()));
      }
      setIsLoading(false);
    };
    loadNavItems();
  }, [companyProductsByUser]);

  return { navItems, isLoading };
};

export default useNavbar;
